import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { OverviewComponent } from './exam/overview/overview.component';
import { loginGuard } from './login.guard';
import { ExamStartComponent } from './exam/start/start.component';
import { EvaluationOverviewComponent } from './question/evaluation-overview/evaluation-overview.component';
import { leaveTestWarningGuard } from './leave-warning.guard';
import { TrainingOverviewComponent } from './training/training-overview/training-overview.component';
import { EndlessStartComponent } from './endless/start/start.component';
import { EndlessExecutionComponent } from './endless/execution/endless-execution.component';
import { ExamExecutionComponent } from './exam/execution/exam-execution.component';
import { RepeatStartComponent } from './repeat/start/start.component';
import { RepeatExecutionComponent } from './repeat/execution/execution.component';
import { CourseOverviewComponent } from './courses/course-overview/course-overview.component';
import { BookmarksComponent } from './profile/bookmarks/bookmarks.component';
import { RegisterComponent } from './auth/register/register.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { IndividualQuestionComponent } from './question/individual-question/individual-question.component';
import { PurchasePageComponent } from './courses/purchase-page/purchase-page.component';
import { GlossaryComponent } from './glossary/glossary.component';
import { ProfileOverviewComponent } from './profile/overview/profile-overview.component';
import { BetaTestComponent } from './beta-test/beta-test.component';

export const routes: Routes = [
    {
        component: OverviewComponent,
        path: '',
        title: 'KnOot Academy',
        canActivate: [loginGuard]
    },
    {
        component: LoginComponent,
        path: 'login',
        title: 'Login | KnOot'
    },
    {
        component: LoginComponent,
        path: 'verify/:token',
        title: 'Login | KnOot'
    },
    {
        component: RegisterComponent,
        path: 'register',
        title: 'Registrierung | KnOot'
    },
    {
        component: ResetPasswordComponent,
        path: 'reset-password/:token',
        title: 'Passwort zurücksetzen | KnOot'
    },
    {
        component: ExamStartComponent,
        path: 'test/create/:id',
        title: 'Prüfungssimulation | KnOot',
        canActivate: [loginGuard]
    },
    {
        component: EndlessStartComponent,
        path: 'endless/start/:id',
        title: 'Endlosmodus | KnOot',
        canActivate: [loginGuard]
    },
    {
        component: EndlessExecutionComponent,
        path: 'endless/:id',
        title: 'Endlosmodus | KnOot',
        canActivate: [loginGuard]
    },
    {
        component: RepeatStartComponent,
        path: 'repeat/start',
        title: 'Fragen wiederholen | KnOot',
        canActivate: [loginGuard]
    },
    {
        component: RepeatExecutionComponent,
        path: 'repeat',
        title: 'Fragen wiederholen | KnOot',
        canActivate: [loginGuard]
    },
    {
        component: ExamExecutionComponent,
        path: 'test/:id',
        title: 'Prüfungssimulation | KnOot',
        canDeactivate: [leaveTestWarningGuard],
        canActivate: [loginGuard]
    },
    {
        component: EvaluationOverviewComponent,
        path: 'evaluation/:id',
        title: 'Ergebnisse | KnOot',
        canActivate: [loginGuard]
    },
    {
        path: 'training',
        redirectTo: "training/all"
    },
    {
        component: TrainingOverviewComponent,
        path: 'training/:selectedCourseId',
        title: 'Trainings | KnOot',
        canActivate: [loginGuard]
    },
    {
        component: CourseOverviewComponent,
        path: 'kurse/:selectedCourseId',
        title: 'Kurse | KnOot',
        canActivate: [loginGuard]
    },
    {
        component: CourseOverviewComponent,
        path: 'kurse',
        canActivate: [loginGuard],
        title: 'Kurse | KnOot'
    },
    {
        component: ProfileOverviewComponent,
        path: 'profile',
        title: 'Profil | KnOot',
        canActivate: [loginGuard]
    },
    {
        component: BookmarksComponent,
        path: 'profile/bookmarks',
        title: 'Gespeicherte Fragen | KnOot',
        canActivate: [loginGuard]
    },
    {
        component: IndividualQuestionComponent,
        path: 'question/:questionId',
        title: 'Einzelne Frage | KnOot'
    },
    {
        component: PurchasePageComponent,
        path: 'purchase/:courseId',
        canActivate: [loginGuard],
        title: 'Kurs kaufen | KnOot'
    },
    {
        component: GlossaryComponent,
        path: 'glossary',
        canActivate: [loginGuard],
        title: 'Glossar | KnOot'
    },
    {
        component: BetaTestComponent,
        path: 'beta-test',
        canActivate: [loginGuard],
        title: 'Beta-Test | KnOot',
        data: { hideShell: true } // Flag, das AppComponent ausliest
    }
];
